var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:[
    'header-navigation__item',
    _vm.menuItem.children ? 'has-children' : '',
  ]},[_c('a',{attrs:{"href":_vm.menuItem.url,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v(_vm._s(_vm.menuItem.title)+" ")]),_vm._v(" "),(_vm.menuItem.children)?_c('ul',{staticClass:"header-navigation__sub-menu is-hidden"},_vm._l((_vm.menuItem.children),function(child,index){return _c('header-navigation-item',{key:index,attrs:{"menu-item":child}})}),1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }